// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Shipments_establishments__3kDaa","header":"Shipments_header__2TT1O","tableHeader":"Shipments_tableHeader__1InqJ"};